import { EnumOption } from "./enum-option";

export const VisaCategory = {
    Family1: 1,
    Family2A: 2,
    Family2B: 3,
    Family3: 4,
    Family4: 5,
    Employment1st: 6,
    Employment2nd: 7,
    Employment3rd: 8,
    Employment4th: 9,
    Employment5thSetAsideRural: 10,
    Employment5thSetAsideHighUnemployment: 11,
    Employment5thSetAsideInfrastructure: 12,
    Employment5thUnreserved: 13,
    EmploymentCertainReligiousWorks: 14,
    EmploymentOtherWorkers: 15,  
};

export const VisaCategoryList: EnumOption[] = [
    { value: VisaCategory.Family1, label: 'F1' },
    { value: VisaCategory.Family2A, label: 'F2A' },
    { value: VisaCategory.Family2B, label: 'F2B' },
    { value: VisaCategory.Family3, label: 'F3' },
    { value: VisaCategory.Family4, label: 'F4' },
    { value: VisaCategory.Employment1st, label: '1st' },
    { value: VisaCategory.Employment2nd, label: '2nd' },
    { value: VisaCategory.Employment3rd, label: '3rd' },
    { value: VisaCategory.Employment4th, label: '4th' },
    { value: VisaCategory.Employment5thSetAsideRural, label: '5th Set Aside: Rural' },
    { value: VisaCategory.Employment5thSetAsideHighUnemployment, label: '5th Set Aside: High Unemployment' },
    { value: VisaCategory.Employment5thSetAsideInfrastructure, label: '5th Set Aside: Infrastructure' },
    { value: VisaCategory.Employment5thUnreserved, label: '5th Unreserved' },
    { value: VisaCategory.EmploymentCertainReligiousWorks, label: 'Certain Religious Workers' },
    { value: VisaCategory.EmploymentOtherWorkers, label: 'Other Workers' },   
];